// extracted by mini-css-extract-plugin
module.exports = {"cta":"Cta-module--cta--1VAWm Box-module--box--X0EGm","actions":"Cta-module--actions--7aaFF"};